import React from "react";

import { Badge, Box, Image, Text, VStack } from "@chakra-ui/react";

import { CctvCamera } from "redux/services/cctv/types";
import { useCameraLocationName } from "../../hooks/useCameraNameLocation";

interface CctvCameraCardProps {
    camera: CctvCamera;
    onClick: () => void;
}

const CctvCameraCard: React.FC<CctvCameraCardProps> = ({ camera, onClick }) => {
    const { CameraLocationName } = useCameraLocationName();
    const isOnline = camera.connection === 1;

    return (
        <Box
            bg="white"
            borderRadius="md"
            overflow="hidden"
            cursor="pointer"
            onClick={onClick}
            transition="all 0.2s"
            _hover={{ transform: "translateY(-2px)"}}
        >
            <Box position="relative">
                <Image
                    src={camera["galleries"][0] || `https://kel-malili.luwutimurkab.go.id/assets/images/notfound.png`}
                    alt={camera.name}
                    w="100%"
                    h="140px"
                    objectFit="cover"
                />
                <Badge
                    position="absolute"
                    top={2}
                    left={2}
                    colorScheme={isOnline ? "red" : "gray"}
                    fontSize="xs"
                    px={2}
                    py={1}
                >
                    {isOnline ? "● Live" : "● Offline"}
                </Badge>
            </Box>
            <VStack align="start" p={3} spacing={1}>
                <Text fontWeight="bold" fontSize="sm" noOfLines={1} marginBottom={0}>
                     {CameraLocationName(camera.name)}
                </Text>
            </VStack>
        </Box>
    );
};

export default CctvCameraCard;
